class CustomersGrid {
    generator = null;
    gridElement = null;
    gridPositions = [];
    logoPointer = -1;
    logos = [];

    constructor(elem) {
        this.gridElement = elem.querySelector('.container');
        this.logos = Array.from(this.gridElement.querySelectorAll('.customers-grid__logo'));
        // Maak een instantie van de generator met de gewenste parameters
        this.generator = new GridGenerator({
            rows: 4,
            cols: 8,
            logoCount: 12,
            blackRatio: 0.3,
            redRatio: 0.7
        });
        this.reset();
        const intervalInMilliseconds = 10000;
        setInterval(() => {
            this.reset();
        }, intervalInMilliseconds);
        document.addEventListener('resize', () => this.reset());
    }

    addBlocksLargeGrid() {
        this.gridPositions = [
            [false, true,  true,  true,  false, false, false, false],
            [true,  true,  true,  true,  false, false, false, false],
            [true,  true,  true,  true,  true,  true,  true,  true],
            [true,  true,  true,  true,  true,  true,  true,  true],
            [true,  true,  true,  true,  true,  true,  true,  true],
            [true,  true,  true,  true,  true,  true,  true,  true],
            [false, false, false, true,  true,  true,  true,  false],
        ];

        const grid = this.generator.generateGrid();

        // Kies willekeurig 20 logo's uit alle beschikbare logo's
        const allLogos = this.logos;
        const shuffledLogos = this.generator._shuffle(allLogos);
        const selectedLogos = shuffledLogos.slice(0, 20);

        grid.forEach((row, rowIndex) => {
            row.forEach((cellValue, colIndex) => {
                if (cellValue === "logo") {
                    const logo = selectedLogos.shift();
                    if (logo) this.displayLogoAtPosition(rowIndex+3, colIndex+1, cellValue);
                }
                else if (cellValue === "black") this.createBlackBlock(rowIndex+3, colIndex+1);
            });
        });

        this.addBlocksToRow(2, false, true);
        this.addBlocksToRow(1, true, true);
        this.addBlocksToRow(7, true);
    }

    addBlocksToRow(r, blackOnly = false, lookDown = false) {
        const rowLookIncrement = lookDown ? 2 : 0;
        let placed = 0;
        for (let c = 1; c <= 8; c++) {
            if (this.gridPositions[r-1][c-1] !== false) {
                let randType = blackOnly ? 2 : Math.ceil(Math.random() * 3);

                if (randType === 1) {
                    //logo
                    if (
                        //geen logo erboven
                        (
                            this.gridPositions[(r-2)+rowLookIncrement][c-1] === 'black'
                            || this.gridPositions[(r-2)+rowLookIncrement][c-1] === false
                            || this.gridPositions[(r-2)+rowLookIncrement][c-1] === true
                        )
                        //logo of zwart er schuin boven links, indien niet eerste positie
                        && (
                            (
                                (c === 1 && this.gridPositions[(r-2)+rowLookIncrement][c] !== true)
                                ||
                                (
                                    this.gridPositions[(r-2)+rowLookIncrement][c-2] !== true
                                    && (
                                        this.gridPositions[(r-2)+rowLookIncrement][c-2] === 'black'
                                        || this.gridPositions[(r-2)+rowLookIncrement][c-2] > 0
                                        || this.gridPositions[(r-2)+rowLookIncrement][c-2] === false
                                    )
                                )
                            )
                            // //logo of zwart er schuin boven rechts, indien niet laatste positie
                            ||
                            (
                                (c === 8 && this.gridPositions[(r-2)+rowLookIncrement][c-2] !== true)
                                ||
                                (
                                    this.gridPositions[(r-2)+rowLookIncrement][c] !== true
                                    && (
                                        this.gridPositions[(r-2)+rowLookIncrement][c] === 'black'
                                        || this.gridPositions[(r-2)+rowLookIncrement][c] > 0
                                    )
                                )
                            )
                        )
                        //links ervan is niet ook logo
                        && !(c > 1 && this.gridPositions[r-1][c-2] !== true && this.gridPositions[r-1][c-2] > 0)
                    ) {
                        this.displayLogoAtPosition(r, c);
                        placed++;
                    }
                }
                else if (randType === 2) {
                    //black
                    if (
                        //geen zwart er boven
                        this.gridPositions[(r-2)+rowLookIncrement][c-1] !== 'black'
                        //logo of zwart er schuin boven links, indien niet eerste positie
                        && (
                            (
                                (c === 1 && this.gridPositions[(r-2)+rowLookIncrement][c] !== true)
                                ||
                                (
                                    this.gridPositions[(r-2)+rowLookIncrement][c-2] !== true
                                    && (
                                        this.gridPositions[(r-2)+rowLookIncrement][c-2] === 'black'
                                        || this.gridPositions[(r-2)+rowLookIncrement][c-2] > 0
                                        || this.gridPositions[(r-2)+rowLookIncrement][c-2] === false
                                    )
                                )
                            )
                            // //logo of zwart er schuin boven rechts, indien niet laatste positie
                            ||
                            (
                                (c === 8 && this.gridPositions[(r-2)+rowLookIncrement][c-2] !== true)
                                ||
                                (
                                    this.gridPositions[(r-2)+rowLookIncrement][c] !== true
                                    && (
                                        this.gridPositions[(r-2)+rowLookIncrement][c] === 'black'
                                        || this.gridPositions[(r-2)+rowLookIncrement][c] > 0
                                    )
                                )
                            )
                        )
                        //links ervan is niet ook zwart
                        && !(c > 1 && this.gridPositions[r-1][c-2] === 'black')
                    ) {
                        this.createBlackBlock(r, c);
                        placed++;
                    }
                }
            }
        }
        if (placed === 0) this.addBlocksToRow(r, blackOnly, lookDown);
    }

    addBlocksSmartphone() {
        this.gridPositions = [
            [false, false, false],
            [false, false, false],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
            [true, true, true],
        ];

        let perRow = 1;
        let prevBlackCol = Math.floor(Math.random() * 2);
        let hadBlackBlock = true;
        for (let r = 3; r <= 17; r++) {
            if (perRow === 1) {
                if (r === 17 || (!hadBlackBlock && Math.floor(Math.random() * 2))) {
                    this.createBlackBlock(r, 2);
                    prevBlackCol = 2;
                    hadBlackBlock = true;
                }
                else {
                    this.displayLogoAtPosition(r, 2);
                    hadBlackBlock = false;
                }
                perRow = 2;
            }
            else {
                if (!hadBlackBlock && (Math.floor(Math.random() * 8) > 0 || r === 3) && r != 17) {
                    prevBlackCol = prevBlackCol === 3 ? 1 : 3;
                    this.createBlackBlock(r, prevBlackCol);
                    this.displayLogoAtPosition(r, prevBlackCol === 1 ? 3 : 1);
                    hadBlackBlock = true;
                }
                else {
                    this.displayLogoAtPosition(r, 1);
                    this.displayLogoAtPosition(r, 3);
                    hadBlackBlock = false;
                }
                perRow = 1;
            }
        }
    }

    createBlackBlock(row, column) {
        const bb = document.createElement('div');
        bb.classList.add('customers-grid__blackblock');
        bb.style.gridColumn = `${column} / span 1`;
        bb.style.gridRow = `${row} / span 1`;
        this.gridElement.appendChild(bb);
        this.gridPositions[row-1][column-1] = 'black';
    }

    displayLogoAtPosition(row, column) {
        this.logoPointer++;
        if ( this.logos.length <= this.logoPointer) this.logoPointer = 0;
        let logoElement = this.logos[this.logoPointer];

        if (logoElement) {
            logoElement.removeAttribute('hidden');
            logoElement.style.gridColumn = `${column} / span 1`;
            logoElement.style.gridRow = `${row} / span 1`;
            this.gridPositions[row-1][column-1] = this.logoPointer+1;
            logoElement.classList.add('show');
        }
    }

    hideLogo(logoElement) {
        logoElement.classList.remove('show');
        logoElement.setAttribute('hidden', '');
        logoElement.style = '';
    }

    reset() {
        //hide logo's
        this.logos.forEach(logo => this.hideLogo(logo));

        //remove black blocks
        this.gridElement.querySelectorAll('.customers-grid__blackblock').forEach(bb => bb.remove());

        if (window.innerWidth < 768) this.addBlocksSmartphone();
        else this.addBlocksLargeGrid();
    }
}

/******************
 * GRID GENERATOR *
 ******************/
class GridGenerator {
    constructor(options = {}) {
        this.rows = options.rows || 5;
        this.cols = options.cols || 8;
        this.totalCells = this.rows * this.cols;
        this.iterations = 0;
        this.maxIterations = options.maxIterations || 1e6;

        this.logoCount = options.logoCount || 20;
        const remaining = this.totalCells - this.logoCount;

        // Zorg dat de verhoudingen kloppen: 20% zwart, 80% rood
        this.blackRatio = options.blackRatio !== undefined ? options.blackRatio : 0.2;
        this.redRatio = options.redRatio !== undefined ? options.redRatio : 0.8;

        this.blackCount = Math.round(remaining * this.blackRatio);
        this.redCount = remaining - this.blackCount;

        // Houd de beschikbare aantallen per type bij
        this.initialAvailable = {
            logo: this.logoCount,
            red: this.redCount,
            black: this.blackCount
        };

        this.types = Object.keys(this.initialAvailable);
    }

    // Genereert het grid en geeft een 2D-array terug
    generateGrid() {
        // Reset de iteratieteller voor elke nieuwe generatie
        this.iterations = 0;

        const grid = Array.from({ length: this.rows }, () => Array(this.cols).fill(null));
        const available = { ...this.initialAvailable };
        const success = this._backtrack(grid, available);

        if (!success) {
            throw new Error("Geen geldige indeling gevonden");
        }
        return grid;
    }

    // MRV-gebaseerde backtracking: kies de lege cel met de minste mogelijke opties
    _backtrack(grid, available) {
        this.iterations++;
        if (this.iterations > this.maxIterations) {
            console.warn("Maximale iteraties overschreden");
            return false;
        }

        // Verzamel alle lege cellen
        let emptyCells = [];
        for (let r = 0; r < this.rows; r++) {
            for (let c = 0; c < this.cols; c++) {
                if (grid[r][c] === null) {
                    emptyCells.push({ r, c });
                }
            }
        }

        // Als er geen lege cellen meer zijn, moeten alle beschikbare aantallen op zijn
        if (emptyCells.length === 0) {
            return Object.values(available).every(count => count === 0);
        }

        // Schud de lege cellen zodat de volgorde willekeurig is
        emptyCells = this._shuffle(emptyCells);

        let nextCell = null;
        let minCandidates = Infinity;
        let candidatesForNext = [];

        // Kijk voor elke lege cel naar het aantal geldige kandidaten
        for (const { r, c } of emptyCells) {
            let candidates = this.types.filter(type => {
                return available[type] > 0 && this._canPlace(grid, r, c, type);
            });
            if (candidates.length < minCandidates) {
                minCandidates = candidates.length;
                nextCell = { r, c };
                candidatesForNext = candidates;
            }
            // Als we een cel tegenkomen met 0 kandidaten, kunnen we direct stoppen.
            if (minCandidates === 0) break;
        }

        if (nextCell === null) {
            return Object.values(available).every(count => count === 0);
        }

        if (candidatesForNext.length === 0) {
            return false;
        }

        // Schud de kandidaten zodat er geen vaste volgorde zit
        const shuffledCandidates = this._shuffle(candidatesForNext);
        for (const type of shuffledCandidates) {
            grid[nextCell.r][nextCell.c] = type;
            available[type]--;

            if (this._backtrack(grid, available)) {
                return true;
            }

            // Backtrack
            grid[nextCell.r][nextCell.c] = null;
            available[type]++;
        }

        return false;
    }

    _canPlace(grid, row, col, type) {
        const directions = [
            [-1, 0],
            [1, 0],
            [0, -1],
            [0, 1]
        ];

        for (const [dr, dc] of directions) {
            const newRow = row + dr;
            const newCol = col + dc;
            if (newRow < 0 || newRow >= this.rows || newCol < 0 || newCol >= this.cols) continue;
            if (grid[newRow][newCol] === type) return false;
        }
        return true;
    }

    _shuffle(array) {
        const arr = array.slice();
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.customers-grid').forEach(grid => new CustomersGrid(grid));
});
